import axios from 'axios'
import Swal from 'sweetalert2'
const API_URL = process.env.REACT_APP_API_URL



export const fetchBotSettings = async (botId) => {
    try {
        const response = await axios.get(`${API_URL}/save-bot-settings/${botId}`)
        return response.data
    } catch (error) {
        console.error('Error fetching colors:', error)
        throw error
    }
}



export const botSettings = async (botId, botSettingData) => {
    try {
        const formData = new FormData()

        if (botSettingData.botImageFile) {
            formData.append('botImage', botSettingData.botImageFile)
        }

        if (botSettingData.botEmail) {
            formData.append('botEmail', botSettingData.botEmail)
        }

        const response = await axios.post(`${API_URL}/save-bot-settings/${botId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })

        console.log(response.data)

        if (response.status === 200) {
            Swal.fire({
                icon: 'success',
                title: 'Bot Settings Updated Successfully',
                showConfirmButton: false,
                timer: 1500,
            })
        }

        return response.data
    } catch (error) {
        console.error('Error updating bot settings:', error)
        Swal.fire('Error', 'Something went wrong while updating bot settings.', 'error')
        throw error
    }
}

